import createDocumentData from "../../utils/createDocumentData";

import { Imprint } from "./types/Imprint";

export default function createImprintData(firebase, data) {
	return Imprint.parse(createDocumentData(firebase, "imprints", data));
}
